import { render, staticRenderFns } from "./Paso4View.vue?vue&type=template&id=4e20b4df&scoped=true&"
import script from "./Paso4View.vue?vue&type=script&lang=js&"
export * from "./Paso4View.vue?vue&type=script&lang=js&"
import style0 from "./Paso4View.vue?vue&type=style&index=0&id=4e20b4df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20b4df",
  null
  
)

export default component.exports